module.exports = __webpack_public_path__ + "static/media/newsletter-july-2019-fair.66d57a72.jpg";